module.exports = __webpack_public_path__ + "files/d99be971854ee02058d25ffb29773c92.png";